const Accordions = ({ accordions }) => {
    return accordions.map(accordion => <>
        <dt dangerouslySetInnerHTML={{ __html: accordion.title }} />
        <dd dangerouslySetInnerHTML={{ __html: accordion.content }} />
    </>);
}
export default Accordions;